export default "__VITE_ASSET__0a0fdc97__"